import type { TagVariant } from "@replo/design-system/components/tag/Tag";
import type { ExperimentStatus } from "schemas/experiment";

export const experimentStatusMapping: Record<
  ExperimentStatus,
  { variant: TagVariant; label: string }
> = {
  active: {
    variant: "success",
    label: "Live",
  },
  draft: {
    variant: "info",
    label: "Draft",
  },
  complete: {
    variant: "neutral",
    label: "Test Ended",
  },
  archived: {
    variant: "neutral",
    label: "Archived",
  },
};
